var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{attrs:{"type":"gradient-facebook","icon":"fa fa-facebook","iconOnly":"","rounded":""},on:{"click":function($event){return _vm.share()}}})}
var staticRenderFns = []

export { render, staticRenderFns }